import { useEffect,useState } from 'react';

interface ConsentData {
  accepted: boolean;
  date: string;
  categories: {
    essential: boolean;
    analytics: boolean;
    marketing: boolean;
  };
}

export const useCookieConsent = () => {
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('cookieConsent');
      setHasConsent(!!consent);
    } catch (error) {
      console.log('Error accessing localStorage:', error);
      setHasConsent(false);
    }
  }, []);

  const saveConsent = (accepted: boolean, selectedCategories = { essential: true, analytics: false, marketing: false }) => {
    try {
      const consentData: ConsentData = {
        accepted,
        date: new Date().toISOString(),
        categories: selectedCategories,
      };
      localStorage.setItem('cookieConsent', JSON.stringify(consentData));
      setHasConsent(true);
      return true;
    } catch (error) {
      console.log('Error saving consent:', error);
      return false;
    }
  };

  return { hasConsent, saveConsent };
};